<template>
    <div>
        <l-card-headline>
            {{ $t("profile.meetings.title") }}
        </l-card-headline>

        <div class="tw-pt-8">
            <l-skeleton-loader v-if="isLoading" />

            <template>
                <div v-if="!activeMeetings.length" class="tw-text-gray-400">
                    {{ $t("profile.meetings.emptyList") }}
                </div>

                <l-meetings-list v-else :meetings="activeMeetings" />
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardHeadline from "@/components/LCardHeadline";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LMeetingsList from "@/components/LUserProfile/LMeetingsList";

import { chronologically } from "@/utils/sort-object";

export default {
    components: {
        LCardHeadline,
        LSkeletonLoader,
        LMeetingsList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
        isVisitor: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: true,
            selectedTab: {
                id: "list",
            },
        };
    },
    computed: {
        ...mapGetters({
            actionItems: "meetings/meetings/actionItems",
            meetings: "meetings/meetings/list",
        }),
        activeMeetings() {
            if (!Array.isArray(this.meetings)) return [];

            return this.meetings
                .filter(meeting => meeting.cycle?.frequency !== "deactivated")
                .sort(chronologically("cycle.nextTime"));
        },
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.isLoading = true;

            try {
                await Promise.all([
                    this.$store.dispatch("meetings/meetings/getList", {
                        payload: { query: { "participants[]": this.user._id } },
                    }),
                ]);
            } finally {
                this.isLoading = false;
            }
        },
        onTabSelect() {
            this.loadData();
        },
    },
};
</script>
